import React, { useState } from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';

import { Heading } from '../../components';

import css from './ListingPage.module.css';
import BlurContent from './BlurContent';

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = typeof publicDataValue != null ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);
      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
        ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
        : schemaType === 'long'
        ? filteredConfigs.concat({ key, value, label })
        : key === 'vin'
        ? filteredConfigs.concat({ key, value, label })
        : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);
  const [isBlur, setIsBlur] = useState(true);

  return existingListingFields.length > 0 ? (
    <section className={css.sectionDetails}>
      <ul className={css.details}>
        {existingListingFields.map(detail => (
          <li key={detail.key} className={css.detailsRow}>
            <span className={css.detailLabel}>
              {detail.label}
              {detail.key === 'vin' && (
                <div onClick={() => setIsBlur(false)} className={css.unblur_sign}>
                  Haz clic para mostrar
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_432_3852)">
                      <path
                        d="M8.00016 1.71289C8.17697 1.71289 8.34654 1.78313 8.47157 1.90815C8.59659 2.03318 8.66683 2.20275 8.66683 2.37956V4.37956C8.66683 4.55637 8.59659 4.72594 8.47157 4.85096C8.34654 4.97599 8.17697 5.04622 8.00016 5.04622C7.82335 5.04622 7.65378 4.97599 7.52876 4.85096C7.40373 4.72594 7.3335 4.55637 7.3335 4.37956V2.37956C7.3335 2.20275 7.40373 2.03318 7.52876 1.90815C7.65378 1.78313 7.82335 1.71289 8.00016 1.71289ZM8.00016 11.7129C8.17697 11.7129 8.34654 11.7831 8.47157 11.9082C8.59659 12.0332 8.66683 12.2027 8.66683 12.3796V14.3796C8.66683 14.5564 8.59659 14.7259 8.47157 14.851C8.34654 14.976 8.17697 15.0462 8.00016 15.0462C7.82335 15.0462 7.65378 14.976 7.52876 14.851C7.40373 14.7259 7.3335 14.5564 7.3335 14.3796V12.3796C7.3335 12.2027 7.40373 12.0332 7.52876 11.9082C7.65378 11.7831 7.82335 11.7129 8.00016 11.7129ZM14.6668 8.37956C14.6668 8.55637 14.5966 8.72594 14.4716 8.85096C14.3465 8.97599 14.177 9.04622 14.0002 9.04622H12.0002C11.8234 9.04622 11.6538 8.97599 11.5288 8.85096C11.4037 8.72594 11.3335 8.55637 11.3335 8.37956C11.3335 8.20275 11.4037 8.03318 11.5288 7.90815C11.6538 7.78313 11.8234 7.71289 12.0002 7.71289H14.0002C14.177 7.71289 14.3465 7.78313 14.4716 7.90815C14.5966 8.03318 14.6668 8.20275 14.6668 8.37956ZM4.66683 8.37956C4.66683 8.55637 4.59659 8.72594 4.47157 8.85096C4.34654 8.97599 4.17697 9.04622 4.00016 9.04622H2.00016C1.82335 9.04622 1.65378 8.97599 1.52876 8.85096C1.40373 8.72594 1.3335 8.55637 1.3335 8.37956C1.3335 8.20275 1.40373 8.03318 1.52876 7.90815C1.65378 7.78313 1.82335 7.71289 2.00016 7.71289H4.00016C4.17697 7.71289 4.34654 7.78313 4.47157 7.90815C4.59659 8.03318 4.66683 8.20275 4.66683 8.37956ZM12.7142 13.0936C12.5891 13.2185 12.4196 13.2887 12.2428 13.2887C12.0661 13.2887 11.8965 13.2185 11.7715 13.0936L10.3575 11.6796C10.2361 11.5538 10.1689 11.3854 10.1704 11.2106C10.1719 11.0358 10.242 10.8686 10.3656 10.745C10.4892 10.6214 10.6564 10.5513 10.8312 10.5498C11.006 10.5483 11.1744 10.6155 11.3002 10.7369L12.7142 12.1502C12.7761 12.2121 12.8253 12.2857 12.8589 12.3666C12.8924 12.4475 12.9097 12.5343 12.9097 12.6219C12.9097 12.7095 12.8924 12.7963 12.8589 12.8772C12.8253 12.9581 12.7761 13.0316 12.7142 13.0936ZM5.64283 6.02222C5.51781 6.1472 5.34827 6.21741 5.1715 6.21741C4.99472 6.21741 4.82518 6.1472 4.70016 6.02222L3.28683 4.60889C3.16174 4.48389 3.09142 4.31431 3.09136 4.13746C3.0913 3.96061 3.16149 3.79098 3.2865 3.66589C3.4115 3.5408 3.58108 3.47048 3.75793 3.47042C3.93477 3.47036 4.1044 3.54055 4.2295 3.66556L5.64283 5.07956C5.76781 5.20458 5.83802 5.37411 5.83802 5.55089C5.83802 5.72767 5.76781 5.89721 5.64283 6.02222ZM3.28683 13.0936C3.16185 12.9685 3.09164 12.799 3.09164 12.6222C3.09164 12.4454 3.16185 12.2759 3.28683 12.1509L4.70083 10.7369C4.76233 10.6732 4.83589 10.6224 4.91723 10.5875C4.99856 10.5526 5.08604 10.5342 5.17456 10.5334C5.26308 10.5326 5.35087 10.5495 5.4328 10.583C5.51473 10.6165 5.58916 10.666 5.65176 10.7286C5.71435 10.7912 5.76386 10.8657 5.79738 10.9476C5.8309 11.0295 5.84777 11.1173 5.847 11.2058C5.84623 11.2943 5.82784 11.3818 5.7929 11.4632C5.75796 11.5445 5.70717 11.6181 5.6435 11.6796L4.23016 13.0936C4.16825 13.1555 4.09472 13.2047 4.01379 13.2383C3.93286 13.2718 3.84611 13.2891 3.7585 13.2891C3.67089 13.2891 3.58413 13.2718 3.5032 13.2383C3.42227 13.2047 3.34874 13.1555 3.28683 13.0936ZM10.3575 6.02222C10.2325 5.89721 10.1623 5.72767 10.1623 5.55089C10.1623 5.37411 10.2325 5.20458 10.3575 5.07956L11.7708 3.66556C11.8958 3.54046 12.0654 3.47015 12.2423 3.47009C12.4191 3.47003 12.5887 3.54022 12.7138 3.66522C12.8389 3.79023 12.9092 3.95981 12.9093 4.13665C12.9094 4.3135 12.8392 4.48313 12.7142 4.60822L11.3002 6.02222C11.1751 6.1472 11.0056 6.21741 10.8288 6.21741C10.6521 6.21741 10.4825 6.1472 10.3575 6.02222Z"
                        fill="#C0C0C0"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_432_3852">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(0 0.379883)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              )}
            </span>
            <span>
              {detail.key === 'vin' ? (
                <BlurContent isBlur={isBlur} text={detail.value} />
              ) : (
                detail.value
              )}
              {detail.key === 'mileage' ? ' km' : ''}
              {detail.key === 'batterycapacity' ? ' kwH' : ''}
              {detail.key === 'horsepower' ? ' CV' : ''}
              {detail.key === 'Power' ? ' kw' : ''}
              {detail.key === 'enginecapacity' ? ' L' : ''}
            </span>
          </li>
        ))}
      </ul>
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
